import Container from "@components/Container/Container";
import { useWindowSize } from "@hooks/useWindowSize";

import SIAFooterDesktop from "./SIAFooterDesktop";
import SIAFooterMobile from "./SIAFooterMobile";

/**
 * Component to display footer in SIA pages
 */
const SIAFooter = (): React.ReactElement => {
  const { isScreenLG } = useWindowSize();

  return (
    <footer
      data-testid="sia-footer-component"
      className="mb-4 bg-gray-850 py-8 font-public-sans lg:py-16"
    >
      <Container rootClassName="flex flex-row justify-center text-white">
        {isScreenLG ? <SIAFooterDesktop /> : <SIAFooterMobile />}
      </Container>
    </footer>
  );
};

export default SIAFooter;
